module.exports = __webpack_public_path__ + "static/media/delivery.5e7da62b.png";